<template>
<div class="map-btn" v-if="map_link()">
    <a :href="map_link()" target="_blank"> карта </a>
</div>    
</template>

<script>
import { google_maps_link } from '../utils';

export default {
    props: ["d"],
    methods: {
        map_link() {
            return google_maps_link([+this.d.latitude, +this.d.longitude]);
        }
    }
}
</script>

<style lang="scss" scoped>
.map-btn {
    width: 4em;
    border: 1px solid var(--col-mainblue);
    padding: 0.3em;
    display: flex;
    justify-content: center;
    // background-color: white;

    &:hover {
        border-color: var(--col-mainblue);
        background-color: var(--col-mainblue);
        a {
            color: var(--col-mainblue);
        }
    }

    a {
        font-weight: 400;
        color: var(--col-mainblue);
        text-decoration: none;
    }
}
</style>